// extracted by mini-css-extract-plugin
export default {"navigation":"GLlRpazN","firstItem":"iJXU0g0S","thumb":"ezqwZM2P"};